module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/deluxe_desktop-14f46bbd5cb583908d395efebda234bf.jpg";